import firebase from "firebase";
import { firebaseConfig } from "../config/firebase_config";


// Firebaseの初期化
export default firebase.initializeApp(firebaseConfig);